export class ExpertTimestampModel {
  public ExpertId: number;
  public TimeStamp: Date;

  public constructor(init?: Partial<ExpertTimestampModel>) {
    Object.assign(this, init);
  }
}
